module.exports = __webpack_public_path__ + "img/f-3_mob.25c945a0.jpg";